import ReducerCreator from '../registerReducer';
import { buildStoreItemFromDictionary, copyStoreItem } from '../storeItemBuilder';
import * as DIGITALSETS from './digitalSets.constants';
import { DigitalSet, DigitalSetSimpleDictionary, DigitalSetWithCode } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

function buildDictionary(set: DigitalSet[]): DigitalSetSimpleDictionary {
    const digitalSets: DigitalSetSimpleDictionary = {};
    set?.forEach(ds => {
        const states: { [code: number]: string } = {};
        ds.stateCollection.forEach(s => states[s.code] = s.name);
        digitalSets[ds.guid] = states;
    });
    return digitalSets;
}

const r = new ReducerCreator<DigitalSetWithCode>()
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_LOAD, (state, payload) => {
        const dic = buildDictionary(payload);
        const res = buildStoreItemFromDictionary(dic);
        res.isLoading = true;
        res.isLoaded = false;
        return res;
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_LOAD_SUCCESS, (state, payload) => {
        const dic = buildDictionary(payload);
        return buildStoreItemFromDictionary(dic);
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_UPDATE, (state, payload) => {
        const dic = buildDictionary(payload);
        const result = (Object as any).assign({}, state, { dictionary: dic, isLoading: true });
        return result;
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_UPDATE_SUCCESS, (state, payload) => {
        const result = copyStoreItem(state.dictionary);
        const dic = buildDictionary(payload);
        Object.keys(dic).forEach(k => result.dictionary[k] = dic[k]);
        result.isLoading = false;
        result.isLoaded = true;
        return result;
    })
    .register<any>(DIGITALSETS.DIGITAL_SETS_UPDATE_ERROR, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: true, errorMessage: payload.reason });
        return result;
    })
    .register<string[]>(DIGITALSETS.DIGITAL_SETS_DELETE, (state, payload) => {
        const result = Object.assign({}, state, { isLoading: true }) ;
        return result;
    })
    .register<DigitalSet[]>(DIGITALSETS.DIGITAL_SETS_DELETE_SUCCESS, (state, payload) => {
        const dic = buildDictionary(payload);
        const result = copyStoreItem(state.dictionary);
        Object.keys(dic).forEach(k => delete result.dictionary[k]);
        result.isLoaded = true;
        result.isLoading = false;
        return result;
    })
    .register<DigitalSet>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<DigitalSetWithCode>();
    })
    ;

export function digitalSetDictionaryReducer(state: StoreItem<DigitalSetWithCode> = new StoreItem<DigitalSetWithCode>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}